import { FC } from 'react'

import { ISvgClass } from '../interface'

const RemovePDFIcon: FC<ISvgClass> = (props) => {
  return (
    <svg
      fill="none"
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      stroke="currentColor"
      {...props}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M6 18L18 6M6 6l12 12"
        fill="inherit"
      />
    </svg>
  )
}

export default RemovePDFIcon
